module.exports = __webpack_public_path__ + "static/img/4.94ff151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4.jpg
// module id = saf7
// module chunks = 1